/**
 * Parses self-signup query params from the route query object.
 *
 * @param {object} query
 * @returns {{groupId: string|null, groupType: string|null, allowSelectGroup: boolean, expireUntil: string|null}}
 *
 * @created_at 29/09/2026 by AI (Composer)
 */
export function parseQueryParams(query) {
	const groupId = query.group || null;
	const groupType = query.group_type || null;
	const allowSelectGroup = query.allow_select_group === 'true' || query.allow_select_group === true;
	let expireUntil = null;
	if (query.expire_until != null && query.expire_until !== 'null' && query.expire_until !== '') {
		expireUntil = query.expire_until;
	}
	return {
		groupId: groupId,
		groupType: groupType,
		allowSelectGroup: allowSelectGroup,
		expireUntil: expireUntil,
	};
}
